import { render } from "./serviceEmail.vue?vue&type=template&id=29288764&scoped=true"
import script from "./serviceEmail.vue?vue&type=script&lang=js"
export * from "./serviceEmail.vue?vue&type=script&lang=js"

import "./serviceEmail.vue?vue&type=style&index=0&id=29288764&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29288764"]])

export default __exports__